/* global angular */
( function () {
	'use strict';

	function promptFactory ( $window, PROMPT_MESSAGES ) {
		var state = 0;

		function init () {
			state = 1;
		}

		function isActive () {
			return state;
		}

		function reset () {
			state = 0;
		}

		function showPrompt () {
			return isActive() && $window.confirm( PROMPT_MESSAGES.beforeunloadMsg + '\n\nPress OK to continue, or Cancel to stay on the current page.' );
		}

		function confirmationHandler ( truthyCallback, falseyCallback ) {
			truthyCallback = truthyCallback || angular.noop;
			falseyCallback = falseyCallback || angular.noop;

			if ( !isActive() ) {
				reset();
				return truthyCallback();
			}

			if ( showPrompt() ) {
				reset();
				truthyCallback();
			} else {
				falseyCallback();
			}
		}

		return {
			'init'                : init,
			'isActive'            : isActive,
			'reset'               : reset,
			'confirmationHandler' : confirmationHandler
		};
	}

	promptFactory.$inject = [ '$window', 'PROMPT_MESSAGES' ];

	angular
		.module( 'app.components' )
		.factory( 'promptFactory', promptFactory );
} )();
